import React from "react"

const articles = ({ searchGroup, results, searchQuery, setMatches, isZeroState, noResults, trackProductClick }) => {
  if (!results || results.length === 0) return null
  if (results && results.length > 0) {
    const isAllZeroData = results.every((element) => element.isZeroData === true)
    if ((!isZeroState || noResults) && isAllZeroData) return null
  }
  return (
    <React.Fragment>
      {results.map((result, index) => {
        const url = `${result.PageUrl_s || result.url}?sq=${searchQuery}`
        const text = result.PageTitle_s || result.name
        const highlight = setMatches(text, searchQuery)
        const groupName = results.isZeroData || isZeroState ? result.displayGroupName : result.HierarchyName_s
        return (
          <li className="general-search-panel__item" key={index}>
            <a href={url} onClick={trackProductClick}>
              <span className="text">
                {highlight.parts.map((part, index) => {
                  if (part.highlight) {
                    return <strong key={index}>{part.text}</strong>
                  } else {
                    return part.text
                  }
                })}
                {groupName ? <em> {groupName}</em> : ""}
              </span>

              <span className="icon">
                <svg className="svg-icon svg-icon--arrowrightangle">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowrightangle">
                    <svg id="svg-arrowrightangle" viewBox="0 0 36 36" width="100%" height="100%">
                      <title>_cph-icons1</title>
                      <path className="cls-1" d="M27.17 18L12.48 33l-3.65-3.71L19.89 18l-11-11.26L12.52 3z" id="ICONS"></path>
                    </svg>
                  </use>
                </svg>
              </span>
            </a>
          </li>
        )
      })}
    </React.Fragment>
  )
}

export default articles
